
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import MetaAttrib from '@/extend/classes/MetaAttrib';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeMetaAttrib' })

export default class storeMetaAttrib extends VuexModule {
  // States
  private reccords: MetaAttrib[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get metaAttribLoading (): boolean {
    return this.dataLoading;
  }
  private get metaAttribRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get metaAttribLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewMetaAttrib() {
    return (): MetaAttrib => { 
      return this.getMetaAttrib(0, true);
    }
  }

  
  public get getMetaAttrib () {
    return (id: number, canCreate = false): MetaAttrib => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id MetaAttrib can't be 0")
        return new MetaAttrib();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new MetaAttrib();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            MetaAttrib.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromMetaAttrib(data.reccords[0] as MetaAttrib);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listMetaAttrib (): MetaAttrib[] {
    return this.reccords;
  }

  public get listConfigMetaAttrib (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mMetaAttribRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mMetaAttribClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mMetaAttribLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mMetaAttribLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(MetaAttrib.fromJson(reccord as MetaAttrib));
    })
    MetaAttrib.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mMetaAttribConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mMetaAttribCreated (obj: MetaAttrib): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareMetaAttrib(obj)) {
          api.fromMetaAttrib(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareMetaAttrib(obj)) {
            api.fromMetaAttrib(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mMetaAttribUpdated (obj: MetaAttrib): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareMetaAttrib(obj)) {
          api.fromMetaAttrib(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mMetaAttribDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerMetaAttrib (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.metaAttribRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerMetaAttrib(this.metaAttribCreated, this.metaAttribUpdated, this.metaAttribDeleted);
          this.mMetaAttribRegistered();
        } else {
          setTimeout(() => resolve(this.registerMetaAttrib(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.metaAttribLoading && !this.metaAttribLoaded) {
          this.mMetaAttribLoading(true);
          return MetaAttrib.list(filter)
            .then((data: ListData) => {
              this.mMetaAttribLoaded(data);
              this.mMetaAttribLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredMetaAttrib (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.metaAttribLoading) {
        this.mMetaAttribLoading(true);
        return MetaAttrib.list(filter)
          .then((data: ListData) => {
            this.mMetaAttribLoaded(data);
            this.mMetaAttribLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  private metaAttribCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mMetaAttribConfigUpdated(config)
    const obj = objConfig.obj as MetaAttrib;
    this.mMetaAttribCreated(MetaAttrib.fromJson(obj));
  }

  @Action
  private metaAttribUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mMetaAttribConfigUpdated(config)
    const obj = objConfig.obj as MetaAttrib;
    this.mMetaAttribUpdated(MetaAttrib.fromJson(obj));
  }

  @Action
  private metaAttribDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as MetaAttrib;
    this.mMetaAttribDeleted(obj.id);
  }
}
